module.exports = __webpack_public_path__ + "img/documents.da2e55eb.svg";